import { Injectable } from '@angular/core';
import { Reference } from '../../models/reference';
import { TerritoryCounters } from '../../models/territory/territory-counters';
import { firstValueFrom } from 'rxjs';
import { territoriesToUIDArray } from '../helpers/territory.helper';
import { ApiService } from './api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ImpacterCountersService {
  territoryMap = new Map<string, {territories: string[], counters: TerritoryCounters | undefined}>();

  constructor(private apiService: ApiService) { }

  async loadTerritory(territoryUid: string) {
    if (this.territoryMap.has(territoryUid)) return;
    const territoryManager = await firstValueFrom(this.apiService.territory.retrieveTerritories(
      territoryUid, true, true
    )).catch(() => undefined);
    if (territoryManager) {
      const data = {
        territories: territoriesToUIDArray([territoryManager.territory]),
        counters: await firstValueFrom(this.apiService.territory.retrieveTerritoryCounters(territoryUid, true))
          .catch(() => undefined)
      };
      this.territoryMap.set(territoryUid, data);
      return data;
    }
    return undefined;
  }

  async setImpactersCounters(impacters: Reference[], referenceTerritory?: string) {
    const relatedDepartments = [...new Set(
      [referenceTerritory, ...impacters.map((impacter) => impacter.departmentUid)]
    )].filter((uid) => uid) as string[];

    for (const deptUid of relatedDepartments) {
      await this.loadTerritory(deptUid);
    }
    impacters.forEach(impacter => {
      const territory = this.territoryMap.get(impacter.departmentUid ?? '');
      if (!territory) return;
      const body = {
        filters: {
          territories: territory.territories.filter(territory => territory.startsWith('FRCOMM')),
          source: territory.counters?.sourcesTerritories.map(source => source.name)
        },
        impacter_id: impacter.id,
        service: 'count'
      };
      // asynchronously call and set impacter's article count as other articles
      this.apiService.article.getArticleCount(body).toPromise().then((res => impacter.articleCount = res));
    });
  }

  async getImpacterReferenceTerritory(id: number, departmentUids: string[]) {
    let mostRelevantTerritory: {uid: string, articleCount: number} | null = null;
    for (const deptUid of departmentUids) {
      await this.loadTerritory(deptUid);
      const territory = this.territoryMap.get(deptUid);
      if (territory?.counters) {
        const articleCount = await firstValueFrom(this.apiService.article.getArticleCount({
          filters: {
            territories: territory.territories.filter(territory => territory.startsWith('FRCOMM')),
            source: territory.counters?.sourcesTerritories.map(source => source.name)
          },
          impacter_id: id,
          service: 'count'
        }));
        if (!mostRelevantTerritory || articleCount > mostRelevantTerritory.articleCount) {
          mostRelevantTerritory = {uid: deptUid, articleCount};
        }
      }
    }
    return mostRelevantTerritory;
  }
}
